import { render } from "./ActivityExerciseDropdown.vue?vue&type=template&id=32b654d0"
import script from "./ActivityExerciseDropdown.vue?vue&type=script&lang=js"
export * from "./ActivityExerciseDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script